import { RichText } from 'prismic-reactjs';
import { Query } from '@prismicio/client';
import { AddToShoppingCartSource } from '@monofront/types';
import { getFormattedCollectionProductBasket } from '@monofront/business/utils';
import { default as CarouselProductBundlesComponent } from '@components/CarouselProductBundles';
import { ICarouselProductBundles } from './types';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapCarouselProductBundles } from './mapCarouselProductBundles';

const CarouselProductBundles: React.FC<ICarouselProductBundles> = ({
  items,
  position,
  primary,
}) => {
  if (!primary || !items || !items.length) return null;

  const formattedProductBasket = getFormattedCollectionProductBasket({
    results: items.map((item) => item.productBundle),
  } as Query);

  if (!formattedProductBasket?.products) return null;

  return (
    <section className="slice-carousel-product-bundles root">
      <div className="content">
        <CarouselProductBundlesComponent
          headerTitle={
            <div className="header">
              <div className="title">
                <RichText render={primary.title} />
              </div>
            </div>
          }
          productBundles={formattedProductBasket.products}
          trackingId={primary.trackingId || undefined}
          containerContext={{
            source: AddToShoppingCartSource.BUNDLE,
            widgetName: primary.trackingId || undefined,
            widgetPosition: position ? `${position}` : undefined,
          }}
        />
      </div>
      <style jsx>{`
        .header {
          display: flex;
          flex-direction: column;
          margin-bottom: var(--space-4);
        }

        .title {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }

        @media (max-width: 800px) {
          .slice-carousel-product-bundles :global(.swiper) {
            margin: var(--negative-padding-layout-base);
            padding: var(--padding-layout-base);
            width: 100vw;
          }
        }
      `}</style>
    </section>
  );
};

export default withSlice(CarouselProductBundles, mapCarouselProductBundles);
